export default __webpack_public_path__ + "static/media/upload-document.b4ad5d61.svg";